// ----------------------------------------------------------------------
// <copyright file="Izenda.RecurrencePattern.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {

  var m = require('mobx');
  var React = require('react');
  var Input = require('share/components/controls/Izenda.Input');
  var DailyRecurrence = require('./Izenda.DailyRecurrence');
  var WeeklyRecurrence = require('./Izenda.WeeklyRecurrence');
  var MonthlyRecurrence = require('./Izenda.MonthlyRecurrence');
  var YearlyRecurrence = require('./Izenda.YearlyRecurrence');
  var ScheduleConstants = require('logic/data/Izenda.ScheduleConstants');
  var localizer = require('share/localization/Izenda.Localizer');
  const { find } = require('lodash/fp');

  var RecurrencePattern = React.createClass({
    propTypes: {
      data: React.PropTypes.object
    },

    getInitialState: function() {
      return {
        isDaily: true,
        isWeekly: false,
        isMonthly: false,
        isYearly: false
      };
    },

    componentWillMount: function() {
      var props = this.props.data;

      this.setState({
        isDaily: props.recurrencePattern === ScheduleConstants.RECURRENCE_PATTERN[0].value,
        isWeekly: props.recurrencePattern === ScheduleConstants.RECURRENCE_PATTERN[1].value,
        isMonthly: props.recurrencePattern === ScheduleConstants.RECURRENCE_PATTERN[2].value,
        isYearly: props.recurrencePattern === ScheduleConstants.RECURRENCE_PATTERN[3].value
      });
    },

    /**
     * get checked
     * @return {boolean} checked
     */
    getChecked: function(recurrence) {
      var props = this.props.data;
      return props.recurrencePattern == recurrence;
    },

    /**
     * onclick recurrence radio
     * @param {object} event
     */
    onClickRecurrence: m.action(function(e) {
      var id = e.target.id;
      var recurrencePattern = find(function(r) {
        return r.label === id;
      }, ScheduleConstants.RECURRENCE_PATTERN);

      var props = this.props.data;
      props.recurrencePattern = recurrencePattern.value;
      // Re-build the recurrencePatternSetting
      this.props.subscription.buildRecurrencePatternSetting();

      this.setState({
        isDaily: id === ScheduleConstants.RECURRENCE_PATTERN[0].label,
        isWeekly: id === ScheduleConstants.RECURRENCE_PATTERN[1].label,
        isMonthly: id === ScheduleConstants.RECURRENCE_PATTERN[2].label,
        isYearly: id === ScheduleConstants.RECURRENCE_PATTERN[3].label
      });
    }),

    /**
     * Render daily section
     * @return {component} DailyRecurrence component
     */
    renderDaily: function() {
      return this.state.isDaily ? <DailyRecurrence {...this.props} /> : null;
    },

    /**
     * Render weekly section
     * @return {component} WeeklyRecurrence component
     */
    renderWeekly: function() {
      return this.state.isWeekly ? <WeeklyRecurrence {...this.props} /> : null;
    },

    /**
     * Render monthly section
     * @return {component} MonthlyRecurrence component
     */
    renderMonthly: function() {
      return this.state.isMonthly ? <MonthlyRecurrence {...this.props} /> : null;
    },

    /**
     * Render yearly section
     * @return {component} YearlyRecurrence component
     */
    renderYearly: function() {
      return this.state.isYearly ? <YearlyRecurrence {...this.props} /> : null;
    },

    /**
     * Render componennt
     * @return {component} component
     */
    render: function() {
      return (
        <div>
          <div>{localizer.getText('DASHBOARD_LABEL_RECURRENCE_PATTERN')}</div>
          <hr />
          <div className="form-group">
            <div className="group-schedule">
              <div className="col-md-3">
                <Input
                  id="daily"
                  type="radio"
                  name="recurrence"
                  onClick={this.onClickRecurrence}
                  checked={this.getChecked(ScheduleConstants.RECURRENCE_PATTERN[0].value)}
                />
                <span className="radio-label">{localizer.getText('SUBSCRIPTION_LABEL_DAILY')}</span>
              </div>
              <div className="col-md-3">
                <Input
                  id="weekly"
                  type="radio"
                  name="recurrence"
                  onClick={this.onClickRecurrence}
                  checked={this.getChecked(ScheduleConstants.RECURRENCE_PATTERN[1].value)}
                />
                <span className="radio-label">{localizer.getText('SUBSCRIPTION_LABEL_WEEKLY')}</span>
              </div>
              <div className="col-md-3">
                <Input
                  id="monthly"
                  type="radio"
                  name="recurrence"
                  onClick={this.onClickRecurrence}
                  checked={this.getChecked(ScheduleConstants.RECURRENCE_PATTERN[2].value)}
                />
                <span className="radio-label">{localizer.getText('SUBSCRIPTION_LABEL_MONTHLY')}</span>
              </div>
              <div className="col-md-3">
                <Input
                  id="yearly"
                  type="radio"
                  name="recurrence"
                  onClick={this.onClickRecurrence}
                  checked={this.getChecked(ScheduleConstants.RECURRENCE_PATTERN[3].value)}
                />
                <span className="radio-label">{localizer.getText('SUBSCRIPTION_LABEL_YEARLY')}</span>
              </div>
            </div>
          </div>
          <div className="border">
            <div className="group">
              {this.renderDaily()}
              {this.renderWeekly()}
              {this.renderMonthly()}
              {this.renderYearly()}
            </div>
          </div>
        </div>
      );
    }
  });

  module.exports = RecurrencePattern;
})();



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.RecurrencePattern.jsx